import React from 'react';
import './LoadingSpinner.css';

function LoadingSpinner({ message = 'Loading...', size = 'normal' }) {
  return (
    <div className="loading-container">
      <div className={`loading-spinner ${size === 'small' ? 'loading-spinner--small' : ''} ${size === 'large' ? 'loading-spinner--large' : ''}`}></div>
      {message && <p className="loading-message">{message}</p>}
    </div>
  );
}

export default LoadingSpinner;
